import React from 'react';

// Lightweight in-house markdown renderer (no external dep)
export function Markdown({ content }) {
    // Simple inline parser - bold, links, headings, lists
    const lines = (content || '').split('\n');
    const blocks = [];
    let buf = [];
    let inList = false;
    let listType = null;
    const flushBuf = () => {
        if (buf.length) {
            blocks.push({ type: 'p', text: buf.join(' ') });
            buf = [];
        }
    };
    const flushList = (items, kind) => {
        if (items.length) blocks.push({ type: kind === 'ol' ? 'ol' : 'ul', items });
    };
    let listItems = [];
    for (let raw of lines) {
        const line = raw.replace(/\r$/, '');
        if (!line.trim()) {
            flushBuf();
            if (inList) { flushList(listItems, listType); listItems = []; inList = false; listType = null; }
            continue;
        }
        if (line.startsWith('### ')) { flushBuf(); blocks.push({ type: 'h3', text: line.slice(4) }); continue; }
        if (line.startsWith('## ')) { flushBuf(); blocks.push({ type: 'h2', text: line.slice(3) }); continue; }
        if (line.startsWith('# ')) { flushBuf(); blocks.push({ type: 'h1', text: line.slice(2) }); continue; }
        if (/^\s*-\s+/.test(line)) {
            flushBuf();
            if (!inList || listType !== 'ul') { flushList(listItems, listType); listItems = []; inList = true; listType = 'ul'; }
            listItems.push(line.replace(/^\s*-\s+/, ''));
            continue;
        }
        if (/^\s*\d+\.\s+/.test(line)) {
            flushBuf();
            if (!inList || listType !== 'ol') { flushList(listItems, listType); listItems = []; inList = true; listType = 'ol'; }
            listItems.push(line.replace(/^\s*\d+\.\s+/, ''));
            continue;
        }
        if (inList) { flushList(listItems, listType); listItems = []; inList = false; listType = null; }
        buf.push(line);
    }
    flushBuf();
    if (inList) flushList(listItems, listType);

    const renderInline = (text) => {
        // **bold**
        const parts = [];
        let rest = text;
        const re = /\*\*(.+?)\*\*/;
        let key = 0;
        while (true) {
            const m = rest.match(re);
            if (!m) { parts.push(rest); break; }
            const idx = m.index;
            if (idx > 0) parts.push(rest.slice(0, idx));
            parts.push(<strong key={`b${key++}`}>{m[1]}</strong>);
            rest = rest.slice(idx + m[0].length);
        }
        return parts;
    };

    return (
        <div className="markdown-body">
            {blocks.map((b, i) => {
                if (b.type === 'h1') return <h1 key={i}>{renderInline(b.text)}</h1>;
                if (b.type === 'h2') return <h2 key={i}>{renderInline(b.text)}</h2>;
                if (b.type === 'h3') return <h3 key={i}>{renderInline(b.text)}</h3>;
                if (b.type === 'ul') return <ul key={i}>{b.items.map((it, j) => <li key={j}>{renderInline(it)}</li>)}</ul>;
                if (b.type === 'ol') return <ol key={i}>{b.items.map((it, j) => <li key={j}>{renderInline(it)}</li>)}</ol>;
                return <p key={i}>{renderInline(b.text)}</p>;
            })}
        </div>
    );
}
